import * as React from 'react'

export const CreateEditApp = () => {
  return <div>Page used to create apps and inside app tab to edit</div>
}
